var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowTopRight = function SvgArrowTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B0D34",
    d: "m21.211 23.106-.002.523.486-.003 1.811-.009.477-.002.002-.513.066-14.914.003-.523-.486.003-13.847.07-.477.003-.002.514-.009 1.95-.002.524.486-.003 9.585-.049-13.39 14.42-.34.366.34.366 1.276 1.373.34.367.34-.367 13.39-14.42-.047 10.324Z"
  })));
};
export default SvgArrowTopRight;